@if (current > limit) {
  <span [iTooltip]="message" class="flex">
    <IIcon name="alertTriangle" class="warning align-bottom" />
  </span>
}
